export enum QuickAddItemTypes {
  Log,
  Incident
}
